import { useSelector } from "react-redux";
import get from "lodash/get";

const useAccess = props => {
	const profile = useSelector(state => state.auth.user);
	const role = get(profile, "role.role");
	const access = props.roles;

	return access.includes(role);
};

export default useAccess;
